import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Accordion, Button, Container, Image, ListGroup, ListGroupItem, Modal, Toast, ToastContainer } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import "../general.css";
import { useCookies } from "react-cookie";
import ans from "./ans.json";

const CommentaryModal = ({ en, modal, closeModal, selectKey }) => {
  const [cookies, setCookie, removeCookie] = useCookies();
  const [toastShow, setToastShow] = useState(false);
  useEffect(() => {
    setToastShow(false);
  }, [])

  const CopyClipboard = (data, caption) => {
    navigator.clipboard.writeText(data);
    setToastShow(caption);
  }

  let copyBtn = [];
  if (en && modal) {
    let list = ans[selectKey].nameHIRA.split('');
    copyBtn = Object.entries(list).map((output, index) => {
      return (
        <>
          <ListGroupItem id={"copybutton_" + String(index)} className='d-grid mx-0 my-1 p-0'>
            <Button variant='light' id={"copybutton_btn" + String(index)} onClick={() => CopyClipboard(output[1])}>COPY "{output[1]}"</Button>
          </ListGroupItem>
        </>
      );
      // copyBtn=
      ;
    });
  }

  return (
    <>
      <Modal show={modal} size='lg' onHide={closeModal} className='text-dark'>
        <Modal.Header closeButton>
          <b>
            {cookies[selectKey] ?
              (en ? ans[selectKey].nameEN : ans[selectKey].nameJA)
              :
              "？？？"
            }
          </b>
        </Modal.Header>
        <Modal.Body className='m-4'>
          {cookies[selectKey] ?
            (<>
              <div dangerouslySetInnerHTML={{ __html: en ? ans[selectKey].textEN : ans[selectKey].textJA }}></div>
              {en ? (
                <>
                  <Accordion className='mt-5' defaultActiveKey="">
                    <Accordion.Item>
                      <Accordion.Header>If you cannot input or understand Japanese letters, please copy and paste them into the cells of crossword in this list.</Accordion.Header>
                      <Accordion.Body>
                        {/* {copyBtn} */}
                        <ListGroup>{copyBtn}</ListGroup>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </>
              ) : (<></>)}
            </>)
            :
            (en ? <>Not yet opened.<br />Please enter password.</> : <>まだ開放されていません。<br />パスワードを入力してください。</>)
          }
          {/* <Image src={'/img/Q/' + selectKey + '.webp'} width="100%"/> */}
        </Modal.Body>

        {en ?
          <>
            <ToastContainer position='bottom-center' className='mb-4'>
              <Toast className='' onClose={() => setToastShow(null)} show={toastShow} delay={2000} autohide>
                <Toast.Body>Copied!!</Toast.Body>
              </Toast>
            </ToastContainer>
          </>
          :
          <></>
        }

      </Modal>

    </>
  )
}

export default CommentaryModal;
